<template>
    <b-container>
        <div class="d-block m-auto text-center pb-4">
            <img width="250px" src="../../assets/img/lost.svg" class="img-fluid">
            <h1 class="text-center mt-4 mb-2">Reset your password</h1>
        </div>
        <p>Please enter your email address that you use to sign into the application below to reset your password. You will
        receive instructions on how to reset your password.</p>
        <b-form v-on:submit.prevent="submit">
            <b-alert :show="showError">
                {{ errorMessage }}
            </b-alert>
            <b-form-group label="Email address">
                <b-form-input type="email" v-model="email" placeholder="Email address"></b-form-input>
                <b-form-invalid-feedback v-if="errors.email">{{ errors.email[0] }}</b-form-invalid-feedback>
            </b-form-group>

            <b-button size="lg" variant="primary" block disabled v-if="loading">
                <b-spinner small type="grow"></b-spinner>
                Loading...
            </b-button>
            <b-button v-else size="lg" type="submit" variant="primary" block>Reset Password</b-button>

        </b-form>
    </b-container>
</template>

<script>
    export default {
        name: "ForgotPassword",

        data(){
            return {
                loading: false,
                email_address: '',
                errors: [],
                showError: false,
                errorMessage: '',
                email: '',
            }
        },

        methods: {
            submit(){
                this.loading = true;
                axios.post('/forgot/password', this.$data).then(response => {
                    this.showError = true;
                    this.errorMessage = response.data.message;
                    this.loading = false;
                }).catch(error => {
                    this.loading = false;
                    this.showError = true;
                    this.errorMessage = error.response.data.message;
                    console.log(this.errorMessage)
                })
            }
        }
    }
</script>

<style scoped>

</style>